import React, { useState, useEffect } from 'react';
import { getProfile, updateProfile } from '../api';
import ImageUploadField from '../components/ImageUploadField';

export default function AdminProfile() {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await getProfile();
        setFormData(res.data);
      } catch (error) {
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (imageUrl) => {
    setFormData((prev) => ({
      ...prev,
      image: imageUrl,
    }));
  };

  const handleBannerImageChange = (imageUrl) => {
    setFormData((prev) => ({
      ...prev,
      bannerImage: imageUrl,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateProfile(formData);
      setMessage('Profile updated successfully!');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage('Error updating profile');
      console.error('Error:', error);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="p-8 text-white">加载中...</div>;

  return (
    <div className="p-8">
      <h2 className="text-3xl font-bold text-white mb-8">编辑个人信息</h2>

      {message && (
        <div className="mb-6 p-4 bg-green-900 text-green-200 rounded-lg">
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6 max-w-2xl">
        <div className="rounded-2xl border border-gray-700 bg-dark-secondary p-6">
          <div className="mb-6">
            <p className="text-xs uppercase tracking-[0.3em] text-gray-500 mb-2">Homepage Identity</p>
            <h3 className="text-xl font-bold text-white">首页主信息</h3>
            <p className="text-sm text-gray-400 mt-2">这里的内容会出现在首页首屏左侧，是访客最先看到的部分。</p>
          </div>

          <div className="space-y-6">
            <div>
              <label className="block text-white font-semibold mb-2">姓名</label>
              <input
                type="text"
                name="name"
                value={formData.name || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
              />
            </div>

            <div>
              <label className="block text-white font-semibold mb-2">职位/标题</label>
              <input
                type="text"
                name="title"
                value={formData.title || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
              />
            </div>

            <div>
              <label className="block text-white font-semibold mb-2">个人简介</label>
              <textarea
                name="description"
                value={formData.description || ''}
                onChange={handleChange}
                rows="4"
                className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
              />
            </div>
          </div>
        </div>

        <div className="rounded-2xl border border-gray-700 bg-dark-secondary p-6">
          <div className="mb-6">
            <p className="text-xs uppercase tracking-[0.3em] text-gray-500 mb-2">Contact</p>
            <h3 className="text-xl font-bold text-white">联系信息</h3>
            <p className="text-sm text-gray-400 mt-2">这些内容会展示在首页的联系方式区域。</p>
          </div>

          <div className="space-y-6">
            <div>
              <label className="block text-white font-semibold mb-2">位置</label>
              <input
                type="text"
                name="location"
                value={formData.location || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
              />
            </div>

            <div>
              <label className="block text-white font-semibold mb-2">邮箱</label>
              <input
                type="email"
                name="email"
                value={formData.email || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
              />
            </div>

            <div>
              <label className="block text-white font-semibold mb-2">电话</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-dark border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-500"
              />
            </div>
          </div>
        </div>

        <div className="rounded-2xl border border-gray-700 bg-dark-secondary p-6">
          <div className="mb-6">
            <h3 className="text-xl font-bold text-white">顶部图片</h3>
            <p className="text-sm text-gray-400 mt-2">上传首页最上方展示的图片。保存后会显示在首屏顶部。</p>
          </div>

          <ImageUploadField
            label="顶部展示图"
            value={formData.bannerImage || ''}
            onChange={handleBannerImageChange}
            folder="banner"
            description="上传后点击“保存更改”。留空时使用默认顶部图片。"
          />
        </div>

        <div className="rounded-2xl border border-gray-700 bg-dark-secondary p-6">
          <div className="mb-6">
            <p className="text-xs uppercase tracking-[0.3em] text-gray-500 mb-2">Profile Image</p>
            <h3 className="text-xl font-bold text-white">个人图片</h3>
            <p className="text-sm text-gray-400 mt-2">这里只维护首页右侧的个人展示图，不再编辑“兴趣特长”内容。</p>
          </div>

          <div>
            <ImageUploadField
              label="个人展示图"
              value={formData.image || ''}
              onChange={handleImageChange}
              folder="profile"
              description="上传后会自动回填图片地址；如果地址失效，前台会自动回退到默认头像。"
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={saving}
          className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 disabled:opacity-50 transition"
        >
          {saving ? '保存中...' : '保存更改'}
        </button>
      </form>
    </div>
  );
}
